export default "__VITE_ASSET__CpkSZ$oW__"